var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedLoggedinImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 289,
    viewBox: "0 0 289 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.75 216.75C256.653 176.847 256.653 112.153 216.75 72.25C176.847 32.3474 112.153 32.3474 72.25 72.25C32.3475 112.153 32.3474 176.847 72.25 216.75C112.153 256.653 176.847 256.653 216.75 216.75Z",
    fill: "#00AE97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.74 190.156C132.376 190.169 131.027 189.88 129.788 189.31C128.549 188.741 127.452 187.904 126.574 186.86L86.4487 139.641C84.8334 137.74 84.0392 135.276 84.2407 132.79C84.4423 130.304 85.6231 128 87.5235 126.385C89.4238 124.77 91.8881 123.975 94.374 124.177C96.8599 124.378 99.164 125.559 100.779 127.46L133.668 166.295L188.052 102.238C189.686 100.435 191.956 99.3375 194.384 99.176C196.812 99.0145 199.207 99.8019 201.065 101.372C202.924 102.942 204.1 105.173 204.346 107.593C204.591 110.014 203.888 112.435 202.383 114.347L140.833 186.86C139.957 187.887 138.87 188.713 137.646 189.282C136.422 189.851 135.089 190.149 133.74 190.156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedLoggedinImg);
export default __webpack_public_path__ + "static/media/checked-loggedin-img.4572b07bdc7ec4104f3211ab824e90fc.svg";
export { ForwardRef as ReactComponent };